import React from 'react';
import {Snackbar} from "material-ui";
import { setStandardSnackbarState } from '@legacy/stores/actions/snackbarActions.js.es6';

const StandardSnackbar = ({ classNames, dispatch, hideAfter, message, visible }) => {
    const className = [
        `bl-snackbar--${visible ? 'visible' : 'hidden'}`,
        classNames
    ].join(' ');

    const onClose = (reason) => {
        if(reason === 'clickaway'){
            setTimeout(() => {
                dispatch(setStandardSnackbarState(message, false, 0));
            }, hideAfter);
        } else {
            dispatch(setStandardSnackbarState(message, false, 0));
        }
    };

    return (
        <Snackbar
            className={ className }
            open={ visible }
            message={ message }
            autoHideDuration={ hideAfter }
            onRequestClose={ onClose }
        />
    );
};

BOOKLIST.components.StandardSnackbar = StandardSnackbar;
export default StandardSnackbar;